// extracted by mini-css-extract-plugin
module.exports = {"h2":"styles_h2__3cSBb"};